// extracted by mini-css-extract-plugin
export default {"withShell":"_1swbuv"};